<template>
  <div class="address-list">
    <van-nav-bar title="我的地址列表" left-text="返回" left-arrow @click-left="$router.go(-1)" />
    <van-address-list
      v-model="chosenAddressId"
      @select="selectAddress"
      :list="list"
      @add="onAdd"
      @edit="onEdit"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      chosenAddressId: "1",
      list: []
    };
  },

  created() {
    this.getAddressList();
  },

  methods: {
    selectAddress(item) { 
      this.$store.commit("updateAddress", item);
      this.$router.push({
        path: "/order/submit/",
        query: this.$route.query
      });
    },

    // 获取地址列表
    getAddressList() {
      let url = "/address/all";
      this.$loading(true);
      this.$get(url)
        .then(result => {
          let addressList = result.list.map(item => {
            // 默认选中的地址
            if (item.isDefault) {
              this.chosenAddressId = item.addressId;
            }

            return {
              id: item.addressId,
              addressId: item.addressId,
              name: item.name,
              tel: item.tel,
              isDefault: item.isDefault,
              address: item.province + item.city + item.addressDetail
            };
          });
          this.list = addressList;
        })
        .catch(err => {
          this.$fail(err);
        });
      this.$loading(false);
    },

    onAdd() {
      this.$router.push("/address/add");
    },

    onEdit(item, index) {
      this.$router.push(`/address/edit/${item.addressId}`);
    }
  }
};
</script> 



